<template>
  <el-select class="select-default country-autcomplete"
             :name="name"
             :placeholder="$t('generic.country')"
             filterable
             clearable
             :value="value"
             v-bind="$attrs"
             v-on="listeners">
    <i slot="prefix" class="nc-icon nc-globe-2"></i>
    <el-option class="select-default"
               v-for="(country, country_code) in countries"
               :key="country.code"
               :label="country.name"
               :value="country.code">
    </el-option>
  </el-select>
</template>

<script>
  import { Select, Option } from 'element-ui';
  import { mapState } from 'vuex';

  export default {
    name: 'country-autocomplete',
    inheritAttrs: false,
    components: {
      [Select.name]: Select,
      [Option.name]: Option
    },
    props: {
      name: String,
      value: String,
      setDefaultCountry: {
        type: Boolean,
        default: false
      }
    },
    computed: {
      listeners() {
        return {
          ...this.$listeners,
          change: this.onChange
        }
      },
      ...mapState({
        countries: state => state.config.countries
      })
    },
    methods: {
      onChange(val) {
        this.$emit('change', val);
        this.findCountryByCode(val)
      },
      findCountryByCode(code) {
        let country = this.countries.find(c => c.code === code)
        if (!country) {
          return
        }
        this.$emit('country-change', country)
      },
      findDefaultCountry (val) {
        if (!val) {
          return
        }
        let primaryCountry = this.countries.find(c => c.primary && c.active)
        if (primaryCountry) {
          this.onChange(primaryCountry.code)
          this.$emit('country-change', primaryCountry)
        }
      }
    },
    watch: {
      setDefaultCountry: {
        immediate: true,
        handler: function(val) {
          this.findDefaultCountry(val)
        }
      }
    }
  }
</script>

<style lang="scss">
  .country-autcomplete {
    width: 100%;
    .el-input__prefix {
      display: flex;
      align-items: center;
      justify-content: center;
    }
  }
</style>
